(function() {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initStoryVideoSection(section) {
    if (!section || section.dataset.storyVideoInitialized === 'true') return;
    section.dataset.storyVideoInitialized = 'true';

    var ticking = false;
    var travel = Number(section.dataset.ornamentTravel || 750);

    function updateOrnaments() {
      ticking = false;

      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var start = viewportHeight;
      var end = -rect.height;
      var raw = (start - rect.top) / (start - end);
      var progress = clamp(raw, 0, 1);
      var eased = progress * progress * (3 - 2 * progress);
      var leftOffset = Math.round(-travel * eased);
      var rightOffset = Math.round(travel * eased);
      var left = section.querySelector('[data-story-ornament="left"]');
      var right = section.querySelector('[data-story-ornament="right"]');
      var isMobile = window.innerWidth < 768;

      if (left) left.style.transform = 'translate3d(0,' + leftOffset + 'px,0)';
      if (right) {
        right.style.transform = isMobile ? 'none' : 'translate3d(0,' + rightOffset + 'px,0)';
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateOrnaments);
    }

    section.querySelectorAll('[data-story-video]').forEach(function(frame) {
      var video = frame.querySelector('video');
      if (!video) return;

      function syncPlaybackState() {
        frame.classList.toggle('is-playing', !video.paused && !video.ended);
      }

      video.addEventListener('play', syncPlaybackState);
      video.addEventListener('pause', syncPlaybackState);
      video.addEventListener('ended', syncPlaybackState);
    });

    section.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-story-video] .story-video-feature__link');
      if (!trigger) return;

      var frame = trigger.closest('[data-story-video]');
      var video = frame && frame.querySelector('video');
      if (!video) return;

      frame.classList.add('is-playing');
      try { video.play(); } catch (e) {}
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  function initAllStoryVideoSections() {
    document.querySelectorAll('[data-story-video-section]').forEach(initStoryVideoSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStoryVideoSections);
  } else {
    initAllStoryVideoSections();
  }

  document.addEventListener('shopify:section:load', initAllStoryVideoSections);
})();
